module.exports = ".very-nice-shadow {\n  background: rgba(0, 0, 0, 0.5); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/all-users/delete-users-modal/delete-users.modal.scss
// module id = ./src/app/admin/all-users/delete-users-modal/delete-users.modal.scss
// module chunks = main